module.exports = __webpack_public_path__ + "static/media/accessible_icon.200756e4.svg";